import { render } from "./SupplierTabs.vue?vue&type=template&id=813e6e2c"
import script from "./SupplierTabs.vue?vue&type=script&lang=js"
export * from "./SupplierTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__